import React, { useState, useEffect, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTelegram } from '../useTelegram';

if (!window.__registrationCache__) {
  window.__registrationCache__ = new Map();
}
const registrationCache = window.__registrationCache__;
const CACHE_DURATION = 5 * 60 * 1000;

function ProtectedRoute({ children }) {
  const [isRegistered, setIsRegistered] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user, isReady, isTelegram } = useTelegram(); // بدون تغییر
  const location = useLocation();

  const apiUrl = useMemo(() => process.env.REACT_APP_API_URL || 'https://api.kurromi.ir', []);

  useEffect(() => {
    const checkRegistration = async () => {
      if (!isTelegram || !isReady) {
        setLoading(false);
        setIsRegistered(true);
        return;
      }

      if (!user?.id) {
        setLoading(false);
        setIsRegistered(false);
        return;
      }

      const userId = user.id.toString();
      const cacheKey = `reg_${userId}`;
      const cached = registrationCache.get(cacheKey);

      if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
        setLoading(false);
        setIsRegistered(cached.isRegistered);
        return;
      }

      try {
        const response = await fetch(`${apiUrl}/api/check-registration`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ telegram_user_id: userId }),
        });

        if (response.ok) {
          const data = await response.json();
          const registered = data.is_registered;
          
          registrationCache.set(cacheKey, {
            isRegistered: registered,
            timestamp: Date.now()
          });
          
          setIsRegistered(registered);
        } else {
          setIsRegistered(false);
        }
      } catch (error) {
        console.error('Error checking registration:', error);
        setIsRegistered(false);
      } finally {
        setLoading(false);
      }
    };

    checkRegistration();
  }, [user?.id, isReady, isTelegram, apiUrl]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        color: '#FF69B4',
        fontSize: '1.5rem'
      }}>
        در حال بارگذاری...
      </div>
    );
  }

  if (!isRegistered) {
    return <Navigate to="/register" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;